import * as actionTypes from './actionTypes';
import * as actions from './index';
import * as DataUtil from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";
import { getSortOptionForSearch } from 'Flow2/components/CustomCollections/CustomDataControllers/CustomSortController';
import { changeTimeForSearch, shouldChangeFilterTypes, updateSearchDataForApps, getContainerType }
    from 'Flow2/components/CustomCollections/CustomDataControllers/CustomSearchController';
import { saveSearchInfo } from "Flow2/components/CustomCollections/CustomDataLog/CustomDataLog";

const configObj = {
    series_series: {
        field: '_cliptype',
        type: '=',
        value: 'series_series'
    },

    series_season: {
        field: '_cliptype',
        type: '=',
        value: 'series_season'
    },

    series_episode: {
        field: '_cliptype',
        type: '=',
        value: 'series_episode'
    },

    series_program: {
        field: '_cliptype',
        type: '=',
        value: 'series_program'
    }
};

const getAddFields = (customSortOption) => {
    return [
        { field: '', type: 'BEGIN_OR', value: '' },
        configObj.series_program, configObj.series_series,
        configObj.series_season, configObj.series_episode,
        { field: '_cliptype', type: 'EMPTY', value: '' },
        { field: '', type: 'END_OR', value: '' },
        customSortOption,
    ]
}

const updateDataForClipsByFields = (data) => {
    let newData = data;
    let containertype = getContainerType(data);
    if (data && containertype)
        newData.push({ field: '', type: 'BEGIN_OR', value: '' }, configObj[containertype],
            { field: '', type: 'END_OR', value: '' });

    if (data && data.find(item => (item.field === "nextinsequence" || item.field === "followsinsequence") && !containertype)) {
        //if (data && !containertype) {
        newData.push({ field: '', type: 'BEGIN_OR', value: '' },
            configObj.series_program, configObj.series_series,
            configObj.series_season, configObj.series_episode,
            { field: '_cliptype', type: 'EMPTY', value: '' },
            { field: '', type: 'END_OR', value: '' });
    }

    return newData;
}

export const searchStart = (type) => {
    return {
        type: actionTypes.SEARCH_START,
        payload: { type: type }
    }
}
export const searchFail = (error) => {
    return {
        type: actionTypes.SEARCH_FAIL,
        error: error
    }
}
export const searchSuccess = (result, type = 'search') => {
    return {
        type: actionTypes.SEARCH_SUCCESS,
        payload: { clips: result, type: type }
    }
}
export const searchNextStart = () => {
    return {
        type: actionTypes.SEARCH_NEXT_START
    }
}
export const searchNextFail = (error) => {
    return {
        type: actionTypes.SEARCH_NEXT_FAIL,
        error: error
    }
}
export const searchNextSuccess = (result) => {
    return {
        type: actionTypes.SEARCH_NEXT_SUCCESS,
        payload: { clips: result }
    }
}

export const searchSetSortDefault = (data) => {
    return {
        type: actionTypes.SEARCH_SET_SORT_DEFAULT,
        payload: data
    }
}

export const searchSetSortOrderDefault = (data) => {
    return {
        type: actionTypes.SEARCH_SET_SORTORDER_DEFAULT,
        payload: data
    }
}

const convertToSearchField = ({ f, params }) => {
    let field = f;
    let type = 'contains';
    let value = params[f];
    let substrFrom = DataUtil.subStringBefore(f, "From");
    let substrTo = DataUtil.subStringBefore(f, "To");
    let substrDate = DataUtil.subStringBefore(f, "CustomDate");
    let substrFromDateTime = DataUtil.subStringBefore(f, "_FromDateTime");
    let substrToDateTime = DataUtil.subStringBefore(f, "_ToDateTime");

    //if (f === 'modelle_ids' || f === 'tags_ids' || f === 'year') return { field: field, type: 'regexp', value: convertApiString(value) };
    if (f === 'id' || f === 'clipid') return { field: field, type: 'LIKE', value: updateSearchDataForApps(value) };

    if (f === `${substrFrom}From`) {
        if (DataUtil.isNLW() && substrFrom === "production_date") field = "production_date_stop";
        else field = substrFrom;
        return { field: field, type: '>=', value: changeTimeForSearch(value, "from") };
    }
    if (f === `${substrTo}To`) {
        if (DataUtil.isNLW() && substrTo === "production_date") field = "production_date_start";
        else field = substrTo;
        return { field: field, type: '<=', value: changeTimeForSearch(value, "to") };
    }

    if (f === `${substrFromDateTime}_FromDateTime`) {
        field = substrFromDateTime;
        return { field: field, type: '>=', value: value };
    }
    if (f === `${substrToDateTime}_ToDateTime`) {
        field = substrToDateTime;
        return { field: field, type: '<=', value: value };
    }

    if (f.includes("_InFromDateTime") || f.includes("_OutToDateTime")) return false;

    if (f === `${substrDate}CustomDate`) return { field: substrDate, type: '=', value: value };

    if (DataUtil.isPMDB()
        && (f === 'videolanguage' || f === 'bildformat' || f === 'eingebrannteuntertitel' /*|| f === 'pmdbid'*/ || f === 'txt4' || f === 'createdby'))
        return { field: field, type: '=', value: value };

    if (!DataUtil.isPMDB() && f === 'status') return { field: field, type: '=', value: value };

    return { field: field, type: type, value: value };

}

const changeIdToName = ({ getState, fields, check }) => {
    let users = getState().admin.users;
    let newValues = [];
    fields = fields.map(item => {
        if (item.field && item.field === check && item.value && users && users.length) {
            item.value.split(";").forEach(el => {
                let found = users.find(user => +user.id === +el);
                if (found && found.username) newValues.push(found.username);
            });
            if (newValues) newValues = newValues.join(";");
            return { ...item, value: newValues };
        }
        return item;
    })
    return fields;
}

const getSearchFields = ({ params }) => {
    let fields = [];
    Object.keys(params).forEach((f) => {
        if (f !== 'offset' && f !== 'limit' && params[f] !== "") {
            if (DataUtil.isPMDB && f === 'txt10_ids') {
                let filter = DataUtil.convertStringToArray(params[f]);
                fields = getSearchFilter(fields, filter);
            }
            if (DataUtil.isPMDB && (f === 'modelle_ids' || f === 'tags_ids' || f === 'year')) {
                params[f].split(";").forEach(item => fields.push({ field: f, type: 'regexp', value: `(^|;)${item}(;|$)` }))
            } else {
                let fieldObj = convertToSearchField({ f, params });
                if (fieldObj) fields.push(fieldObj);
            }
        }
    });
    fields.push({ field: 'archiv', type: '=', value: 0 });
    return fields;
}

const getSearchFilter = (fields, selectedData) => {
    let filter = [...selectedData];
    let maxLength = 4;
    if (selectedData.length > 1 && selectedData.length < maxLength) {
        fields.push({ field: '', type: 'BEGIN_OR', value: '' });
    }
    let audioIndex = filter.indexOf("audio");
    if (filter.length === 3 && audioIndex === -1) {
        fields = fields.filter(item => item.field !== "media" && item.field !== "");
        fields.push({ field: 'media', type: 'NOT CONTAINS', value: 'audio' });
    }
    if (filter.length > 0 && audioIndex !== -1) {
        if (filter.length > 0 && filter.length < maxLength)
            fields.push({ field: 'media', type: 'CONTAINS', value: 'audio' });

        filter.splice(audioIndex, 1);
    }

    if (filter.length > 0 && filter.length < 3) {
        if (filter.length === 1) {
            if (filter.indexOf('video') > -1) {
                fields.push({ field: 'media', type: 'CONTAINS', value: 'video' });
                if (selectedData.length > 1 && selectedData.length < maxLength)
                    fields.push({ field: '', type: 'END_OR', value: '' });
            }
            if (filter.indexOf('pictures') > -1) {
                fields.push({ field: 'media', type: 'CONTAINS', value: 'pictures' });
                if (selectedData.length > 1 && selectedData.length < maxLength)
                    fields.push({ field: '', type: 'END_OR', value: '' });

                fields.push({ field: 'media', type: 'NOT CONTAINS', value: 'video' });
            }
            if (filter.indexOf('other') > -1) {
                if (selectedData.length > 1 && selectedData.length < maxLength) {
                    fields = fields.filter(item => item.field !== "media" && item.field !== "");
                } else {
                    fields.push({ field: 'media', type: 'NOT CONTAINS', value: 'audio' });
                }
                fields.push({ field: 'media', type: 'NOT CONTAINS', value: 'video' });
                fields.push({ field: 'media', type: 'NOT CONTAINS', value: 'pictures' });
            }
        } else if (filter.length === 2) {
            if (filter.indexOf('video') > -1 && filter.indexOf('pictures') > -1) {
                fields.push({ field: 'media', type: 'CONTAINS', value: 'video' });
                fields.push({ field: 'media', type: 'CONTAINS', value: 'pictures' });
                fields.push({ field: '', type: 'END_OR', value: '' });
            }
            if (filter.indexOf('video') > -1 && filter.indexOf('other') > -1) {
                fields.push({ field: 'media', type: 'CONTAINS', value: 'video' });
                fields.push({ field: 'media', type: 'CONTAINS', value: 'other' });
                fields.push({ field: '', type: 'END_OR', value: '' });
                fields.push({ field: 'media', type: 'NOT CONTAINS', value: 'pictures' });
            }
            if (filter.indexOf('pictures') > -1 && filter.indexOf('other') > -1) {
                fields.push({ field: 'media', type: 'CONTAINS', value: 'pictures' });
                fields.push({ field: 'media', type: 'CONTAINS', value: 'other' });
                fields.push({ field: '', type: 'END_OR', value: '' });
                fields.push({ field: 'media', type: 'NOT CONTAINS', value: 'video' });
            }
        }
    }
    return fields;
}

const extendFulltextSearch = (params) => {
    // TODO
    // replace ++ with + in loop
    // replace -- with - in loop
    /*while(params.keyword.indexOf('++') !== -1) {
        params.keyword = params.keyword.replace('++', '+');
    }*/

    let keywords = params.keyword.split(' ');
    if (keywords.length > 1) {
        //let first = "";
        keywords.forEach((keyword, index) => {
            if (keyword.length) {
                keywords[index] = getKeyword(keyword);
                /*first = keyword.charAt(0);
                if (first !== '+' && first !== '-') {
                    keywords[index] = concatKeyword(keyword, '+');
                } else if (first === '+') {
                    keywords[index] = concatKeyword(keyword.substring(1), '+');
                } else if (first === '-') {
                    keywords[index] = concatKeyword(keyword.substring(1), '-');
                }*/
            }
        });
    } else if (keywords.length/* && hasSpecialChar(keywords[0])*/) {
        keywords[0] = getKeyword(keywords[0], false);//'"' + keywords[0] + '"';
    }

    //console.log(keywords, keywords.join(' '));

    return keywords.join(' ');
}

/*
const concatKeyword = (keyword, operator) => {
    if (hasSpecialChar(keyword)) {
        return operator + '"' + keyword + '"';
    }
    return operator + keyword;
}
*/

/*
const hasSpecialChar = (str) => {
    return str.match(/\W/) !== null;
}
*/
const maskKeyword = (word) => {
    if (word.match(/\W/)) {
        return '"' + word + '"';
    }
    return word;
}

// build array [ operator, word, star ]
// 
const getKeyword = (word, concat = true) => {
    let test = word;
    const keyword = concat ? ["+", test, ""] : ["", test, ""];
    const operator = test.match(/^\+|-/);
    const star = test.match(/\*$/);

    // set +/- operator and extract substring
    if (operator) {
        test = test.slice(1);

        if (concat) {
            keyword[0] = operator[0];
        } else {
            // set - operator if only one term set
            if (operator[0] === "-") {
                keyword[0] = operator[0];
            }
        }
    }

    // set star operator and extract substring
    if (star) {
        test = test.slice(0, -1);
        keyword[2] = "*";
    }

    if (!test.length) {
        return "";
    }

    keyword[1] = maskKeyword(test);

    //console.log(keyword.join(''));

    return keyword.join('');
}

const searchFullText = (params, remoteSearch, filter, customSortOption, dispatch, getState, isNextSearch = false) => {
    const clipsPerPage = 50;
    let offset = 0;
    if (isNextSearch) offset = params.offset ? params.offset : 0;
    const showArchived = "0";

    if (getState().customData.customFullTextSearchData) {
        params.keyword = getState().customData.customFullTextSearchData;
    }

    if (params && params.keyword) {
        params.keyword = extendFulltextSearch(params);
    }

    let fields = [{ field: 'archiv', type: '=', value: showArchived }, customSortOption];
    fields = getSearchFilter(fields, filter);
    if (DataUtil.isNLW()) {
        let addFields = getAddFields(customSortOption);
        fields = [...fields, ...addFields];
    }
    let extObj = { ...remoteSearch, offset: offset, limit: clipsPerPage, fields: fields };
    if (!DataUtil.isPMDB()) extObj.fields = extObj.fields.filter(item => item.field !== 'archiv');
    //console.log("LAMTEST searchFullText fields", fields);
    window.flow.getClipsByFulltext(params.keyword, extObj
    ).then((result) => {
        dispatch(actions.getCustomLastSearch({ searchType: 'fulltext', keyword: params.keyword }));
        if (isNextSearch) {
            dispatch(searchNextSuccess(result));
        }
        else {
            dispatch(actions.getCustomLastSearch({ searchType: 'fulltext', keyword: params.keyword }));
            dispatch(searchSuccess(result));
            dispatch(actions.setClipList(null, null));
        }
    }).catch((res) => {
        console.log(res);
        isNextSearch ? dispatch(searchNextFail(res.message)) : dispatch(searchFail(res.message));
        dispatch(actions.applicationError(res.message));
    })
}


const handleDistLgText = ({ params, fields, getState }) => {
    if (params) {
        let lg = params.distribution_languages;
        fields = fields.filter(item => item.field !== 'distribution_languages');
        if (params.distribution_all) {
            let valueArr = params.distribution_all.trim().split(/\s+/);
            if (lg) {
                fields.push({ field: `distribution_languages`, type: 'FIND_IN_SET', value: lg });
                valueArr.forEach(item => {
                    fields.push({ field: `distribution_json_${lg}-all`, type: 'regexp', value: `:"[^"]*${item}[^"]*"[,|}]` }); // `:\"[^\"]*${item}[^\"]*\"[,|}]`
                })
            } else {
                let lgArr = getState().customData.customUiConfigForApp.DISTRIBUTION_LANGUAGES;
                valueArr.forEach(el => {
                    if (lgArr && lgArr.length) {
                        fields.push({ field: "", type: "BEGIN_OR", value: "" });
                        lgArr.forEach(item => fields.push({ field: `distribution_json_${item}-all`, type: 'regexp', value: `:"[^"]*${el}[^"]*"[,|}]` })); // `:\"[^\"]*${el}[^\"]*\"[,|}]`
                        fields.push({ field: "", type: "END_OR", value: "" });
                    }
                })
            }
            fields = fields.filter(item => item.field !== 'distribution_all');
        } else {
            if (lg) {
                fields.push({ field: `distribution_languages`, type: 'FIND_IN_SET', value: lg });
            }
        }

    }
    return fields;
}

const searchByFields = (params, fields, remoteSearch, customSortOption, dispatch, getState, isNextSearch = false) => {
    const showArchived = "0";
    const clipsPerPage = 50;
    let offset = 0;
    let msg = isNextSearch ? "NextSearching" : "Starting";
    if (isNextSearch) offset = params.offset ? params.offset : 0;
    saveSearchInfo(dispatch, msg, " ", 'SearchClipByFieldsStart');
    saveSearchInfo(dispatch, params, " ", 'Searchdata');
    if (isNextSearch) {
        fields = getState().customData.customLastByFieldsData;
        fields = fields.filter(obj => obj.field !== "archiv");
    } else {
        fields = getSearchFields({ params });
        if (DataUtil.isPMDB()) {
            fields = fields.filter(item => item.field !== 'txt10' && item.field !== 'txt10_ids' && item.field !== 'customCurrentSortOption');
        }
        else fields = fields.filter(item => item.field !== 'customCurrentSortOption');
    }

    dispatch(actions.setCustomLastByFieldsData([...fields]));
    fields.push({ field: 'archiv', type: '=', value: showArchived }, customSortOption);
    if (DataUtil.isNLW()) {
        fields = updateDataForClipsByFields(fields);
    }
    if (!DataUtil.isPMDB()) {
        fields = fields.filter(item => item.field !== 'archiv');
    }
    saveSearchInfo(dispatch, fields, " ", 'SearchClipByFields');

    if (DataUtil.isPMDB()) {
        fields = handleDistLgText({ fields, params, getState });
        fields = changeIdToName({ fields, getState, check: 'lastmodifiedby' });
    }
    //console.log("LAMTEST searchByFields fields", fields);
    //console.log("LAMTEST searchByFields remoteSearch", remoteSearch);
    window.flow.getClipsByFields(fields, { ...remoteSearch, offset: offset, limit: clipsPerPage }).then((result) => {
        //console.log("LAMTEST searchByFields result", result);
        if (isNextSearch) dispatch(searchNextSuccess(result));
        else {
            dispatch(actions.getCustomLastSearch({ searchType: 'byfields', params: params }));
            dispatch(searchSuccess(result));
        }
        saveSearchInfo(dispatch, result, " ", 'SearchClipByFieldsStatus');
        if (result.objects && result.objects.elements) saveSearchInfo(dispatch, result.objects.elements, " ", 'SearchClipByFieldsElements');
        dispatch(actions.setClipList(null, null));
    }).catch((res) => {
        console.log(res);
        if (isNextSearch) dispatch(searchNextFail(res.message));
        else dispatch(searchFail(res.message));
        dispatch(actions.applicationError(res.message));
    })
}

const searchByIds = (params, fields, remoteSearch, customSortOption, dispatch) => {
    const clipsPerPage = 50;
    const offset = 0;
    fields = [{ field: 'id', type: 'IDLIST', value: params.value }, customSortOption];
    window.flow.getClipsByFields(fields, { ...remoteSearch, offset: offset, limit: clipsPerPage }).then((result) => {
        dispatch(searchSuccess(result));
        dispatch(actions.setClipList(null, null));
    }).catch((res) => {
        console.log(res);
        dispatch(searchFail(res.message));
        dispatch(actions.applicationError(res.message));
    })
}

const searchlatestMedia = (media, fields, params, type, customSortOption, dispatch) => {
    const showArchived = "0";
    fields = [{ field: 'archiv', type: '=', value: showArchived }, customSortOption];
    fields = getSearchFilter(fields, [media]);
    window.flow.getClipsByFulltext(params.keyword,
        {
            offset: 0,
            limit: 16,
            fields: fields
        }).then((result) => {
            dispatch(searchSuccess(result, type));
            dispatch(actions.setClipList(null, null));
        }).catch((res) => {
            console.log(res);
            dispatch(searchFail(res.message));
            dispatch(actions.applicationError(res.message));
        });
}

export const search = (type, params) => {
    let customSortOption = getSortOptionForSearch(params);
    let fields;

    return (dispatch, getState) => {
        dispatch(searchStart(type));
        dispatch(actions.resetTickedClips());
        dispatch(actions.resetMultiSelected());
        //Data for SearchNext
        dispatch(actions.setCustomLastSearchType(type));
        const filter = getState().ui.filter;
        const clipListFilter = getState().clipList.filter;
        let customFilter = getState().customData.customCurrentMainFilter;
        if (customFilter && shouldChangeFilterTypes(filter, clipListFilter)) {
            dispatch(actions.setCliplistFilter(filter));
        }
        let configClipInfo = getState().customData.customConfigClipInfoForApp;
        customSortOption.field = DataUtil.getSortOptionsForApp(customSortOption.field, configClipInfo);
        if (customSortOption.field === 'undefined') customSortOption.field = 'id';
        const devices = Object.keys(getState().devices.searchDevices);
        const remoteSearch = (devices.length) ? { remoteserverdevice: devices.join(','), combineremote: true } : {};
        switch (type) {
            case 'fulltext':
                if (filter.length === 0) {
                    dispatch(searchFail('no filter set'));
                    break;
                }
                searchFullText(params, remoteSearch, filter, customSortOption, dispatch, getState);
                break;
            case 'byids':
                searchByIds(params, fields, remoteSearch, customSortOption, dispatch);
                break;
            case 'byfields':
                searchByFields(params, fields, remoteSearch, customSortOption, dispatch, getState);
                break;
            case 'latestvideos':
                searchlatestMedia('video', fields, params, type, customSortOption, dispatch);
                break;
            case 'latestpictures':
                searchlatestMedia('pictures', fields, params, type, customSortOption, dispatch);
                break;
            default:
                dispatch(searchFail('Can do only fulltext search at the moment.'));
                dispatch(actions.applicationError('Can do only fulltext search at the moment.'));
        }
    }
}

export const searchNext = (type, params) => {
    let customSortOption = getSortOptionForSearch(params);
    let fields;
    return (dispatch, getState) => {
        dispatch(searchNextStart());
        if (getState().customData.customLastSearchType === "byfields") type = "byfields";
        const filter = getState().ui.filter;
        const devices = Object.keys(getState().devices.searchDevices);
        const remoteSearch = (devices.length) ? { remoteserverdevice: devices.join(','), combineremote: true } : {};
        let configClipInfo = getState().customData.customConfigClipInfoForApp;
        customSortOption.field = DataUtil.getSortOptionsForApp(customSortOption.field, configClipInfo);
        if (customSortOption.field === 'undefined') customSortOption.field = 'id';
        switch (type) {
            case 'fulltext':
                if (filter.length === 0) {
                    dispatch(searchFail('no filter set'));
                    break;
                }
                searchFullText(params, remoteSearch, filter, customSortOption, dispatch, getState, true);
                break;
            case 'byfields':
                searchByFields(params, fields, remoteSearch, customSortOption, dispatch, getState, true);
                break;
            default:
                dispatch(searchNextFail('Can do only fulltext search at the moment.'));
                dispatch(actions.applicationError('Can do only fulltext search at the moment.'));
        }
    }
}
